import { render, staticRenderFns } from "./verify-sign-up.vue?vue&type=template&id=a4bd7c22&scoped=true&"
import script from "./verify-sign-up.vue?vue&type=script&lang=js&"
export * from "./verify-sign-up.vue?vue&type=script&lang=js&"
import style0 from "./verify-sign-up.vue?vue&type=style&index=0&id=a4bd7c22&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bd7c22",
  null
  
)

export default component.exports